// Named by pixel value, not tier (sm/md/lg): these are ad hoc per-component
// cutoffs rather than a coordinated design scale, so a semantic name would
// overclaim a relationship between them that doesn't exist. Values are
// preserved exactly as they were before centralizing here.
const breakpoints = {
  mobileHeading: "502px",
  px370: "370px",
  px421: "421px",
  px496: "496px",
  px571: "571px",
  px620: "620px",
  px642: "642px",
  px670: "670px",
  px700: "700px",
  px920: "920px",
  px978: "978px",
  px1000: "1000px",
};

export default breakpoints;
